/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';

const SortIconString = ({ name, activeSort }) => {
  const sortSplit = activeSort.split('-');
  const activeName = sortSplit?.[0] ? sortSplit[0] : '';
  const activeCode = sortSplit?.[1] ? sortSplit[1] : '';

  const isActiveName = name === activeName;

  if (!isActiveName) {
    return (<FontAwesomeIcon icon={faSort} />)
  }

  return (
    <>
      {activeCode === 'desc' ? <FontAwesomeIcon icon={faSortDown} /> : ''}
      {activeCode === 'asc' ? <FontAwesomeIcon icon={faSortUp} /> : ''}
    </>
  )
}

SortIconString.defaultProps = {
  activeSort: ''
}

SortIconString.propTypes = {
  name: PropTypes.string,
  activeSort: PropTypes.string,
}

export default SortIconString;
